<template>
  <v-select
    v-model="selected"
    return-object
    :items="options"
    item-text="text"
    item-value="value"
    :hide-details="true"
    dense
    outlined
    rounded
    append-icon="icon-arrow-down"
    full-width
    :prefix="prefix"
    :menu-props="{
      contentClass: 'facilities-sorting-option-select__menu',
      offsetY: true
    }"
    class="facilities-sorting-option-select"
    @input="updateSelectedOption"
  >
  </v-select>
</template>

<script>
export default {
  name: "FacilitiesFilterSelect",
  props: {
    options: {
      type: Array,
      required: true
    },
    prefix: {
      type: String
    }
  },
  data() {
    return {
      selected: {}
    };
  },
  created() {
    this.selected = this.options.length ? this.options[0] : {};
  },
  methods: {
    updateSelectedOption(filterOption) {
      this.$emit("update", filterOption.value);
    }
  }
};
</script>

<style lang="scss" src="./FacilitiesSelect.scss"></style>
